module.exports = __webpack_public_path__ + "static/img/icon_szh_wdfw_syhbs.ee8824a9.png";